import { isKalamaBrandingEnabled } from 'src/modules/brand/utils/kalama-branding'
import classes from './powered-by.module.scss'
import type { PoweredByProps } from './powered-by.interface'

const POWERED_BY_URL =
  'https://www.smsreminder.app?utm_source=booking_page&utm_medium=web&utm_campaign=Booking_Page_Referral_Link'

// Public booking pages do not follow the owner's locale, so the footer stays hard-coded English.
export function PoweredBy({ className, linked = true }: PoweredByProps) {
  const label = isKalamaBrandingEnabled() ? 'Powered by Kalama (formerly SMS Reminder ®)' : 'Powered by SMS Reminder ®'

  if (!linked) return <div className={className}>{label}</div>

  return (
    <div className={className}>
      <a className={classes.link} href={POWERED_BY_URL} target="_blank" rel="noopener noreferrer">
        {label}
      </a>
    </div>
  )
}
